import { createGlobalStyle } from "styled-components";

// Fonts are loaded from Google Fonts (PRD allows it; no CORS tricks needed).
// Reset + mobile-first base. Respects Telegram's safe-area insets.
export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');

  *, *::before, *::after { box-sizing: border-box; }

  html, body, #root {
    margin: 0;
    padding: 0;
    height: 100%;
  }

  body {
    background: ${({ theme }) => theme.color.base};
    color: ${({ theme }) => theme.color.text};
    font-family: ${({ theme }) => theme.font.ui};
    font-size: 15px;
    line-height: 1.45;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    overscroll-behavior-y: none;
  }

  #root {
    display: flex;
    flex-direction: column;
  }

  button {
    font-family: inherit;
    cursor: pointer;
  }

  input, textarea {
    font-family: inherit;
  }

  a { color: ${({ theme }) => theme.color.accent}; }

  /* Hide scrollbars but keep scroll — terminal aesthetic */
  ::-webkit-scrollbar { width: 0; height: 0; }
`;
